<!--  -->
<template>
  <div class="abnormal_box">
    <div style="display:flex" class="header-search search_box">
      <div>
        <el-input
          v-model="queryobj.appId"
          placeholder="请输入公众号appid"
        />
      </div>
      <div>
        <el-select
          v-model="queryobj.errorLogType"
          class="marg"
          placeholder="异常信息类型"
        >
          <el-option
            v-for="item in optionsone"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </div>
      <div>
        <el-button
          type="primary"
          class="marg"
          icon="el-icon-search"
          @click="searcher"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="editchong"
        >重置</el-button>
      </div>
    </div>

    <el-table :data="tableData" border style="width: 100%;margin-top:20px">
      <el-table-column
        align="center"
        prop="errorLogTypeStr"
        label="异常类型"
      />
      <el-table-column align="center" prop="appId" label="appid" width="180" />
      <el-table-column
        prop="officialAccountName"
        align="center"
        label="绑定公众号"
      >
        <!-- <template slot-scope="scope">
          <div class="tag">
            <el-tag v-for="items,indexs in scope.row.officialAccounts.slice(0, 2)" :key="indexs" class="tag_item">{{ items }}</el-tag>
            <el-link v-for="items,indexs in scope.row.officialAccounts.slice(0, 1)" :key="indexs" :underline="false" type="primary" class="tag_item">{{ items }}</el-link>
            <el-tag class="tag_item">{{ scope.row.officialAccountName }}</el-tag>
            <el-link type="primary" :underline="false" @click="lookmore(scope.row.officialAccounts)">查看更多</el-link>
          </div>
        </template> -->
      </el-table-column>
      <el-table-column
        align="center"
        prop="createdAt"
        label="异常时间"
      />
      <el-table-column align="center" prop="logInfo" label="异常信息" width="310" />
    </el-table>

    <pagination-right
      :total="templatetotalrwe"
      :page-sizes="[15]"
      @size-change="temfetchPageSizeone"
      @current-change="temfetchCurrentPageone"
    />
    <el-dialog
      title="查看"
      :visible.sync="bandVisibler"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <lookbandaccount ref="Banddialogviewr" />
    </el-dialog>
  </div>
</template>

<script>
import {
  officialSearchlist,
  adminbusinesserrorLog,
  adminerrorLog
} from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import lookbandaccount from './components/lookbandaccount.vue'
export default {
  name: 'AbnormalList',
  components: {
    PaginationRight,
    lookbandaccount
  },
  data() {
    return {
      options: [],
      optionsone: [],
      tableData: [],
      templatetotalrwe: null,
      queryobj: {
        appId: null,
        errorLogType: null,
        page: 1,
        pageSize: 15
      },
      bandVisibler: false
    }
  },
  created() {
    this.getofflist()
    this.getabnormallist()
    this.getbusinesserrorlog()
  },
  mounted() {},
  methods: {
    //  获取筛选列表
    async getofflist() {
      const data = await officialSearchlist({
        accountName: ''
      })
      this.options = data.data.list
    },
    //  获取筛选列表
    async getabnormallist() {
      const data = await adminbusinesserrorLog()
      this.optionsone = data.data.list
    },
    // 获取列表
    async getbusinesserrorlog() {
      const data = await adminerrorLog(this.queryobj)
      this.tableData = data.data.data.list
      this.templatetotalrwe = data.data.data.total
      console.log('data', data)
    },
    searcher() {
      this.getbusinesserrorlog()
    },
    editchong() {
      this.queryobj = {
        appId: null,
        errorLogType: null,
        page: 1,
        pageSize: 10
      }
      this.getbusinesserrorlog()
    },
    temfetchPageSizeone(e) {
      this.queryobj.pageSize = e
      this.getbusinesserrorlog()
    },
    temfetchCurrentPageone(e) {
      this.queryobj.page = e
      this.getbusinesserrorlog()
    },
    lookmore(arr) {
      this.bandVisibler = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.Banddialogviewr.sendr(arr)
      }, 100)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.abnormal_box {
  padding: 20px;
}
.tag {
  display: flex;
  margin-right: 10px;
}
.tag_item {
  width: 100%;
  text-align: center;
}
.marg{
  margin-left:10px;
}
</style>
